module.exports = __webpack_public_path__ + "img/c2.1eee8182.png";